import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능: 권한없음 페이지
 * 세부설명:
*/

export class NoAuthencation extends Component {
    static displayName = NoAuthencation.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }


    render() {
        return (
            <div>
                <div className="alert_box_out">
                    <div className="alert_box">
                        <div className="page_alert_icon"></div>
                        <div className="alert_pop_txt">사용 권한이 없습니다.</div>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={(e) => {
                        window.location.href = "/"
                    }}>확인</button>
                </div>
            </div>
        );
    }
}
